(function () {
    var instances = document.querySelectorAll('.product-simple-info--collapse');
    if (!instances.length) return;

    function collapsedPixelHeight(root) {
        let value = root.getAttribute('data-collapsed-height') || '200';
        return Number(value);
    }

    function initInstance(root, index) {
        var content = root.querySelector('.product-simple-info--content-inner');
        var toggle = root.querySelector('.product-simple-info__toggle');
        var fade = root.querySelector('.product-simple-info__fade');
        if (!content || !toggle) return;

        var expandedState = false;

        // Tạo id duy nhất cho ARIA
        var uid = 'product-simple-info-content-id-' + (index + 1);
        content.id = content.id || uid;
        toggle.setAttribute('aria-controls', content.id);

        function isExpanded() {
            return root.classList.contains('readmore--expanded');
        }

        function setExpanded(expanded) {
            expandedState = expanded;
            var collapsed = collapsedPixelHeight(root);
            if (expanded) {
                if (getComputedStyle(content).maxHeight === 'none') {
                    content.style.maxHeight = content.scrollHeight + 'px';
                    content.offsetHeight;
                }
                content.style.maxHeight = content.scrollHeight + 'px';
            } else {
                if (getComputedStyle(content).maxHeight === 'none' || content.style.maxHeight === '' || content.style.maxHeight === 'none') {
                    content.style.maxHeight = content.scrollHeight + 'px';
                    content.offsetHeight;
                }
                content.style.maxHeight = collapsed + 'px';
            }

            root.classList.toggle('readmore--expanded', expanded);
            toggle.setAttribute('aria-expanded', String(expanded));
            content.setAttribute('aria-expanded', String(expanded));
        }

        function updateVisibility() {
            var needsToggle = content.scrollHeight > collapsedPixelHeight(root) + 1;
            toggle.style.display = needsToggle ? 'inline-flex' : 'none';
            if (fade) fade.style.display = needsToggle ? '' : 'none';
        }

        toggle.addEventListener('click', function () {
            setExpanded(!isExpanded());
        });

        content.addEventListener('transitionend', function (e) {
            if (e.propertyName !== 'max-height') return;
            if (expandedState) {
                content.style.maxHeight = 'none';
            }
        });

        window.addEventListener('resize', updateVisibility);
        content.style.maxHeight = collapsedPixelHeight(root) + 'px';
        updateVisibility();
    }

    instances.forEach(initInstance);
})();